import cookie from './cookie';

export default {
  error: (...args: unknown[]) => {
    const isDebugMode = !!cookie('debug').get();

    if (isDebugMode) {
      console.log(...args);
    }
  },
};
